import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { tipoMovimentoEntradaAdapter } from "@/data";
import { toast } from "@/hooks/use-toast";
import type { TipoMovimentoEntrada } from "@/types/tabelas-auxiliares";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: TipoMovimentoEntrada | null;
  onSuccess: () => void;
}

export function TipoMovimentoDeleteDialog({ open, onOpenChange, item, onSuccess }: Props) {
  const handleConfirm = async () => {
    if (!item || item.sistema) return;
    try {
      await tipoMovimentoEntradaAdapter.delete(item.id_tipo_movimento);
      toast({ title: "Sucesso", description: "Tipo de movimento excluído com sucesso!" });
      onSuccess();
      onOpenChange(false);
    } catch (error) {
      toast({ title: "Erro", description: "Não foi possível excluir.", variant: "destructive" });
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir Tipo de Movimento</AlertDialogTitle>
          <AlertDialogDescription>
            {item?.sistema ? "Registros de sistema não podem ser excluídos." : `Tem certeza que deseja excluir permanentemente "${item?.nome}"? Esta ação não pode ser desfeita.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={item?.sistema}>Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
